import { DashboardModel } from '../models/dashboard.model';

export const USER_CARDS: DashboardModel[] = [
  {
    title: 'Vertragsliste',
    description: 'Liste der bestehenden Verträge',
    icon: 'account_circle',
    route: '/vertragsliste'
  },
  {
    title: 'Neuer Vertrag',
    description: 'Einen neuen Vertrag erstellen',
    icon: 'description',
    route: '/neuer-vertrag'
  }
];

export const ADMIN_CARDS: DashboardModel[] = [
  {
    title: 'Vorlagenliste',
    description: 'Vorlage hinzufügen, bearbeiten oder löschen',
    icon: 'people',
    route: '/vorlagenliste'
  },
  {
    title: 'Neue Vorlage',
    description: 'Neue Vorlage hinzufügen',
    icon: 'settings',
    route: '/neue-vorlage'
  }
];
